import { create } from "zustand";
import { persist } from "zustand/middleware";

// Constants
import { ROWRENDERERCONST } from '~/constants/rowRenderers';

interface UserState {
    user: any;
    team: any;
    setUser: (user: any) => void;
    setTeam: (team: any) => void;
    resetUser: () => void;
    resetTeam: () => void;
}

const getInitialTeam = () => {
    if (typeof window === "undefined") return undefined;

    const storedTeam = localStorage.getItem(ROWRENDERERCONST.__PICKED_TEAM);

    if (storedTeam && storedTeam !== "undefined" && storedTeam !== "null") {
        try {
            return JSON.parse(storedTeam);
        } catch {
            return undefined;
        }
    }
    return undefined;
};

export const useUserStore = create<UserState>()(
    persist(
        set => ({
            user: undefined,
            team: getInitialTeam(),
            setUser: user => set({ user }),
            setTeam: team => {
                set({ team });
                // Also update legacy team storage for backwards compatibility
                if (typeof window !== "undefined") {
                    localStorage.setItem(
                        ROWRENDERERCONST.__PICKED_TEAM,
                        JSON.stringify(team),
                    );
                }
            },
            resetUser: () => set({ user: undefined }),
            resetTeam: () => {
                set({ team: undefined });
                if (typeof window !== "undefined") {
                    localStorage.removeItem(ROWRENDERERCONST.__PICKED_TEAM);
                }
            },
        }),
        {
            name: "user-storage",
            partialize: state => ({
                team: state.team, // Only persist team, user should be handled by session
            }),
        },
    ),
);
